import React from 'react';
import createSvgIcon from '../utils/createSvg';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M145.4 30.3c70.1.3 126.9 57.2 126.9 127.3C272.3 228 215.4 285 145 285S17.7 227.9 17.7 157.6h21.8c0 58.3 47.2 105.5 105.5 105.5s105.5-47.2 105.5-105.5c0-58-47-105.2-105-105.5v25.3l-43.8-36.2L145.4 5v25.3z"
})), 'SkipBackIcon');